import React, { useState } from "react";
import { Loader2, Send, Headset, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../../lib/api";
import { apiErr } from "../../../lib/apiErr";

export function PreviewTab({ a, isNew, readOnly, dirty }) {
  const [msg, setMsg] = useState("");
  const [log, setLog] = useState([]);
  const [session, setSession] = useState(null);
  const [busy, setBusy] = useState(false);
  if (isNew) return <p className="rounded-xl bg-slate-50 px-4 py-4 text-xs text-slate-500" data-testid="agent-preview-needs-save">Simpan agent dulu untuk mencoba pratinjau.</p>;
  if (readOnly) return <p className="rounded-xl bg-slate-50 px-4 py-4 text-xs text-slate-500">Pratinjau hanya untuk Super Admin.</p>;
  const send = async () => {
    const m = msg.trim(); if (!m) return;
    setBusy(true); setMsg(""); setLog((l) => [...l, { who: "me", text: m }]);
    try { const r = await api.post(`/platform/support-agents/${a.id}/preview`, { message: m, session_id: session }); setSession(r.data.session_id || null); setLog((l) => [...l, { who: "ai", text: r.data.reply || "", model: r.data.model }]); }
    catch (e) { toast.error(apiErr(e, "Gagal menghasilkan balasan")); } finally { setBusy(false); }
  };
  return (
    <div className="aivora-card p-5" data-testid="agent-preview">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs text-slate-500">Uji chat dengan persona, knowledge & model agent ini (konfigurasi tersimpan).{dirty && <b className="text-amber-600"> Simpan dulu agar perubahan ikut diuji.</b>}</p>
        {log.length > 0 && <button onClick={() => { setLog([]); setSession(null); }} className="btn-soft inline-flex items-center gap-1 rounded-lg px-2 py-1 text-[11px] font-bold" data-testid="agent-preview-reset"><RotateCcw size={11} /> Sesi baru</button>}
      </div>
      <div className="mt-4 max-h-[420px] space-y-3 overflow-y-auto" data-testid="agent-preview-log">
        {log.map((m, i) => (
          <div key={i} className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm ${m.who === "me" ? "ml-auto bg-brand text-white" : "bg-slate-100 text-slate-800"}`} data-testid={`agent-preview-msg-${i}`}>
            {m.who === "ai" && <p className="mb-1 flex items-center gap-1 text-[11px] font-bold text-brand"><Headset size={11} /> {a.name}{m.model ? ` · ${m.model}` : ""}</p>}
            <p className="whitespace-pre-wrap">{m.text}</p>
          </div>
        ))}
        {busy && <p className="flex items-center gap-2 text-xs text-slate-400"><Loader2 size={13} className="animate-spin" /> Menyusun balasan…</p>}
      </div>
      <div className="mt-4 flex gap-2">
        <input className="input-ui flex-1" maxLength={2000} placeholder="Tulis pertanyaan uji…" value={msg} onChange={(e) => setMsg(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && !busy) send(); }} data-testid="agent-preview-input" />
        <button onClick={send} disabled={busy || !msg.trim()} className="btn-primary inline-flex items-center gap-1.5 rounded-xl px-4 text-xs font-bold disabled:opacity-50" data-testid="agent-preview-send"><Send size={13} /> Kirim</button>
      </div>
    </div>
  );
}
